import React, { useState } from 'react';  // import the React library
import '../App.css'; // import your CSS file
import { motion } from 'framer-motion';
import BioLine from '../articleComponents/bioLine.js'; // import your CSS file
import Connect from '../articleComponents/connect';
import SocialMedia from '../articleComponents/SocialMedia';
import MetaTags from '../mainPageComponents/MetaTags';
import Image from '../mainPageComponents/image.js';
import TraversePosts from '../articleComponents/navigation';
import yummyChips from '../images/choc.jpg';

const today = new Date("12, 29, 2020").toLocaleDateString('en-US', {  
  day:   'numeric',
  month: 'short',
  year:  'numeric',
  weekday: 'long'
});

const number = 1;

function ABigDecision() {

const pics = [
  'https://i.imgur.com/g7wB5kI.jpg',
  'https://i.imgur.com/SPrG2WA.jpg',
  'https://cdn.theculturetrip.com/wp-content/uploads/2017/10/north_of_israel_6859671064.jpg',
  yummyChips 
];

const [ picCount, setPicCount] = useState(0);

function updatePic() {
   if ((picCount + 1) === pics.length) {
     return pics.length;
   } else {
    setPicCount(c => c + 1);
   }
}

const [ count1, setCount] = useState(number);
const [ count2, setCount2] = useState(20);

const [ email, setEmail] = useState("");
const [ password, setPassword] = useState("");

  return (
      <motion.div className="articleStyle"
        initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>

<MetaTags title="A Big Decision" desc="Do I see my code render or do I eat a piece of chocolate. To be or not to be?" 
URL="https://highway-60.web.app/articles/a-big-decision" imageURL="/images/choc.jpg" />

<h1 id="top" style={{marginTop: '2em'}}>A Big Decision <br/>

<button style={{fontSize: '1.5em'}} onClick={() => {
  setCount(c => c + 1);
  setCount2(c => c + 5);
  }}>
  +
</button>
{count1}
{count2}

<button style={{fontSize: '1.5em'}} onClick={() => {
  setCount(c => c - 1);
  setCount2(c => c - 5);
  }}>
  -
</button>

</h1>

<div>
  <input name="email" value={email} onChange={e => setEmail(e.target.value) } />
  <input type="password" name="password" value={password} onChange={e => setPassword(e.target.value) } />
</div>

<Image picURL={pics[picCount]} alt="Do a code or take a chip break?" />
<button style={{fontSize: '2em', color: 'white', backgroundColor: 'teal', borderColor: 'white', borderRadius: '10px', marginTop: '5px'}} onClick={updatePic}
>&nbsp;Click for a new Picture&nbsp;</button>

<BioLine />
<p>{today}</p>

<div style={{textAlign: "left", marginTop: "5px", marginBottom: "20px"}}>
<SocialMedia url="https://highway-60.web.app/articles/a-big-decision" title="Highway 60" hashtag="#highway60" hashtagArray={["coding", "writing"]} via="TheHighway60" desc="Do I see my code render or do I eat a piece of chocolate? To be or not to be." />

</div>

    <p>I am coding something new. It has been about 45 minutes of intense concentration.</p>

<p>
It’s about to happen. After all this work, and not a small amount of anticipation, I am ready to rumble. It’s time to execute. 
</p>

<p>
Just as I am ready to hit that <b>npm start</b>, my wife surprises me. 
</p>

<p>
She went to Garenei Afula, the local candy store. We are about to go into COVID-19 lockdown so we made sure to have a two weeks supply of sweets for the kids. 
</p>

<p>
She got a special stash for the both of us. 
</p>

<p>
The kids will be home in 20 minutes, so she breaks out the bag and offers me a little. 
</p>

<p>
Now I have a choice to make:    
</p>

<p>
Do I render, or take a piece?    
</p>

<p>
No brainer. I stop, dig my hand in, and take out three pieces. 
</p>

<p>
Pecan covered in chocolate. It was a good choice. 
</p>

<p>
Liquor in a dark chocolate ball. Still rolling.     
</p>

<p>
Then I face the great impasse:
</p>

<p>
The third chocolate falls on the floor. 
</p>

<p>
Do I get on the floor to retrieve my delicacy or do I run my latest render?
</p>

<br />

<h1>
Three Second Rule
</h1>

<br />

<p>
I gotta see this baby in action. 
</p>

<p>
The program renders, the chocolate is sitting right under my hard drive. As long as it doesn’t melt, it can wait. 
</p>

<p>
Ugghhhh!
</p>

<p>
An error. 
</p>

<p>
It’s a pretty simple one, I can tackle it within a minute or so. 
</p>

<p>
But what about the chocolate? 
</p>

<p>
That’s a tough one: Eat a chocolate or debug something. 
</p>

<p>
My boss is a hard-core developer. He would be proud of my next decision. 
</p>

<p>
My wife has a sweet tooth. She would kill me. 
</p>

<p>
I’ll just work fast. 
</p>

<p>
Uy vey, another bug. 
</p>

<p>
More debugging or some chocolate?
</p>

<p>
Finally, I get the thing going. Instead of my standard fist clutch, I get on all fours.
</p>

<p>
“Just what are you doing?” asks my wife.
</p>

<p>
Busted. 
</p>

{/** lets put some useState() right here and see what happens */}

<TraversePosts prevURL="/articles/hello-world" nextURL="/articles/the-dating-game"/>

<Connect />
</motion.div>
  );
}

export default ABigDecision;
